module.exports = __webpack_public_path__ + "static/media/key-skeleton.72f00fb5.svg";